import successIcon from "../assets/icons/successIcon.svg";
import errorIcon from "../assets/icons/errorIcon.svg";
import warningIcon from "../assets/icons/warningIcon.svg";
import infoIcon from "../assets/icons/infoIcon.svg";
import { ToastContent } from "./types/common";
import { toast, ToastOptions } from "react-toastify";

type ToastType = 'success' | 'error' | 'warning' | 'info';

const getToastIcon = (type: ToastType) => {
    switch (type) {
        case 'success':
            return <img src={successIcon} alt="success-icon" />;
        case 'error':
            return <img src={errorIcon} alt="error-icon" />;
        case 'warning':
            return <img src={warningIcon} alt="warning-icon" />;
        case 'info':
            return <img src={infoIcon} alt="info-icon" />;
    }
};

export const getToastTitle = (type: ToastType): string => {
    switch (type) {
        case 'success':
            return 'Success';
        case 'error':
            return 'Error';
        case 'warning':
            return 'Warning';
        case 'info':
            return 'Information';
    }
};

export const ToastMessage = ({ title, message }: ToastContent) => (
    <div className="flex flex-col">
        <h4 className="toast-title">{title}</h4>
        <p className="toast-message">{message}</p>
    </div>
);


const TOASTER_CONFIGS = (type: ToastType) => ({
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    icon: getToastIcon(type)
});

export const showErrorToast = (msg: string) => {
    toast.error(
        <ToastMessage title={getToastTitle('error')} message={msg} />,
        TOASTER_CONFIGS('error') as ToastOptions
    );
};

export const showSuccessToast = (msg: string) => {
    toast.success(
        <ToastMessage title={getToastTitle('success')} message={msg} />,
        TOASTER_CONFIGS('success') as ToastOptions
    );
};

export const showInfoToast = (msg: string) => {
    toast.info(
        <ToastMessage title={getToastTitle('info')} message={msg} />,
        TOASTER_CONFIGS('info') as ToastOptions
    );
};

export const showWarningToast = (msg: string) => {
    toast.warning(
        <ToastMessage title={getToastTitle('warning')} message={msg} />,
        TOASTER_CONFIGS('warning') as ToastOptions
    );
};


export { TOASTER_CONFIGS, type ToastType };